var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2971 8.41439V18.6716C23.2971 18.7448 23.2971 18.8128 23.2863 18.8807L18.8308 16.6798L19.9245 21.709H4.36547C2.63609 21.709 1.23535 20.3498 1.23535 18.6716V8.41439C1.23535 6.74145 2.63609 5.37695 4.36547 5.37695H5.27057V7.20673C5.27057 8.10071 6.01943 8.83262 6.94607 8.83262C7.87272 8.83262 8.62158 8.10071 8.62158 7.20673V5.37695H16.0725V7.20673C16.0725 8.10071 16.8213 8.83262 17.748 8.83262C18.6746 8.83262 19.4235 8.10071 19.4235 7.20673V5.37695H20.1669C21.8963 5.37695 23.2971 6.74145 23.2971 8.41439Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75098 16.2363H14.678",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75098 12.8164H19.4244",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7635 21.0973L23.5559 21.8083L21.0184 26.7382L19.9247 21.709L18.8311 16.6797L23.2865 18.8807L27.7635 21.0973Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62249 3.88761V7.20735C8.62249 8.10133 7.87363 8.83324 6.94699 8.83324C6.02034 8.83324 5.27148 8.10133 5.27148 7.20735V3.88761C5.27148 2.9884 6.02034 2.26172 6.94699 2.26172C7.41031 2.26172 7.83053 2.4447 8.13223 2.73746C8.43393 3.03023 8.62249 3.438 8.62249 3.88761Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4233 3.88761V7.20735C19.4233 8.10133 18.6744 8.83324 17.7478 8.83324C16.8211 8.83324 16.0723 8.10133 16.0723 7.20735V3.88761C16.0723 3.438 16.2608 3.03023 16.5625 2.73746C16.8642 2.4447 17.2844 2.26172 17.7478 2.26172C18.6744 2.26172 19.4233 2.9884 19.4233 3.88761Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner3);
export default __webpack_public_path__ + "static/media/banner3.9e2257462b1cd86b0fed024383ca9e41.svg";
export { ForwardRef as ReactComponent };